import * as React from 'react'
import { SVGProps } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={250}
    viewBox="0 0 1260 675"
    height={56}
    {...props}
  >
    <defs>
      <clipPath id="a">
        <path d="M.934 0h1258.132v674H.934Zm0 0" />
      </clipPath>
      <clipPath id="b">
        <path d="M.934 42.734H328V279H.934Zm0 0" />
      </clipPath>
      <clipPath id="c">
        <path d="M453 242h165.02v21H453Zm0 0" />
      </clipPath>
      <clipPath id="d">
        <path d="M227 377h177v254.363H227Zm0 0" />
      </clipPath>
      <clipPath id="e">
        <path d="M227 377h206v254.363H227Zm0 0" />
      </clipPath>
    </defs>
    <g clipPath="url(#a)" fill="#fff">
      <path d="M.934 0h1258.132v681.492H.934Zm0 0" />
      <path d="M.934 0h1258.132v674H.934Zm0 0" />
      <path d="M.934 0h1258.132v674H.934Zm0 0" />
    </g>
    <g clipPath="url(#b)">
      <path fill="#6422b8" d="m.934 42.879 119.804 204.52 207.207 30.636Zm0 0" />
      <path fill="#ffa53b" d="m.934 42.879 67.558 16.215 259.453 218.941Zm0 0" />
    </g>
    <path fill="#ffa53b" d="M327.945 278.035 50.473 233.891 218.94 373.539Zm0 0" />
    <path fill="#ffd93b" d="m327.945 278.035-2.254 138.297-106.75-42.793Zm0 0" />
    <path fill="#ffa53b" d="m310.824 265.418 74.774-41.441 23.422 33.335Zm0 0" />
    <path fill="#a548ff" d="m385.598 223.977 67.117 18.918-45.047 14.417Zm0 0" />
    <path fill="#6422b8" d="m310.824 265.418 97.293 67.129-.449-75.235Zm0 0" />
    <g clipPath="url(#c)">
      <path fill="#6422b8" d="m453.61 242.45 164.41 2.25-154.051 18.019Zm0 0" />
    </g>
    <path fill="#a548ff" d="m453.61 242.45-45.493 90.097 55.852-69.828Zm0 0" />
    <path fill="#ffd93b" d="m407.668 257.313 45.941-14.864-45.492 90.098Zm0 0" />
    <path fill="#6422b8" d="m327.945 279.836-2.254 182.898 33.778-24.324Zm0 0" />
    <path
      fill="#ffa53b"
      d="m327.945 278.035 80.172 54.512L359.47 438.41ZM227.945 377.14l97.29 212.641-37.829 11.707Zm0 0"
    />
    <path fill="#6422b8" d="m227.945 377.14 21.625 144.157 37.836 80.191Zm0 0" />
    <g clipPath="url(#d)">
      <path fill="#6422b8" d="M403.613 631.219 227.945 377.14l97.29 212.64Zm0 0" />
    </g>
    <path fill="#ffa53b" d="m227.945 377.14 98.645 40.098v44.594Zm0 0" />
    <g clipPath="url(#e)">
      <path fill="#ffd93b" d="M227.945 377.14 403.613 631.22l28.832-81.989Zm0 0" />
    </g>
    <path fill="#ffa53b" d="M465.77 549.23h-33.325L326.59 461.832Zm0 0" />
    <path fill="#a548ff" d="m359.469 438.41 106.3 110.82-139.18-87.398Zm0 0" />
    <path
      fill="#100f0d"
      d="M428.688 268.258a5.163 5.163 0 0 1-5.165 5.156c-2.832 0-5.148-2.312-5.148-5.156a5.156 5.156 0 0 1 5.148-5.149c2.852 0 5.164 2.305 5.164 5.149"
    />
    <path
      d="M472.219 381.558v22.563h39.5v15.843h-39.5v31.079h-19.75v-85.329h64.484v15.844ZM616.418 418.496c0 .25-.125 1.96-.375 5.125h-49.609c.895 4.062 3.008 7.273 6.344 9.625 3.332 2.355 7.476 3.53 12.437 3.53 3.407 0 6.426-.503 9.063-1.515 2.644-1.02 5.11-2.625 7.39-4.812l10.11 10.969c-6.18 7.062-15.196 10.593-27.047 10.593-7.399 0-13.938-1.437-19.625-4.312-5.688-2.883-10.078-6.883-13.172-12-3.086-5.125-4.625-10.938-4.625-17.438 0-6.425 1.52-12.218 4.563-17.375 3.05-5.156 7.238-9.175 12.562-12.062 5.32-2.883 11.273-4.328 17.86-4.328 6.413 0 12.222 1.382 17.421 4.14 5.196 2.762 9.282 6.727 12.25 11.89 2.97 5.157 4.453 11.15 4.453 17.97Zm-34.015-19.625c-4.305 0-7.918 1.218-10.844 3.656-2.93 2.437-4.715 5.773-5.36 10h32.298c-.649-4.145-2.434-7.457-5.36-9.938-2.93-2.476-6.508-3.718-10.734-3.718Zm0 0"
      fill="#a548ff"
    />
    <path
      d="m731.23 451.043-.124-51.188-25.11 42.172h-8.906l-24.984-41.078v50.094h-18.532v-85.329h16.344l31.938 53.032 31.437-53.032h16.219l.234 85.329ZM818.243 384.496c10.164 0 17.968 2.418 23.406 7.25 5.445 4.836 8.172 12.125 8.172 21.875v37.422h-17.797v-8.172c-3.574 6.093-10.234 9.14-19.984 9.14-5.043 0-9.415-.851-13.11-2.547-3.7-1.707-6.523-4.066-8.469-7.078-1.949-3.008-2.921-6.422-2.921-10.234 0-6.094 2.289-10.883 6.875-14.375 4.593-3.5 11.687-5.25 21.28-5.25h15.11c0-4.145-1.262-7.332-3.781-9.563-2.524-2.238-6.297-3.359-11.328-3.359-3.5 0-6.938.555-10.313 1.656-3.367 1.094-6.226 2.575-8.578 4.438l-6.828-13.281c3.57-2.52 7.852-4.47 12.844-5.844 5-1.383 10.14-2.078 15.422-2.078Zm-1.453 54.718c3.25 0 6.132-.75 8.656-2.25 2.52-1.5 4.304-3.71 5.36-6.64v-6.703h-13.048c-7.804 0-11.703 2.558-11.703 7.672 0 2.437.953 4.37 2.86 5.796 1.914 1.418 4.539 2.125 7.875 2.125ZM956.964 360.605v90.438h-18.172v-7.563c-4.71 5.688-11.531 8.531-20.469 8.531-6.18 0-11.765-1.379-16.765-4.14-5-2.758-8.922-6.696-11.766-11.813-2.844-5.125-4.266-11.055-4.266-17.797 0-6.75 1.422-12.68 4.266-17.797 2.844-5.125 6.766-9.066 11.766-11.828 5-2.758 10.586-4.14 16.765-4.14 8.364 0 14.907 2.64 19.625 7.922v-31.813Zm-35.36 75.813c4.801 0 8.786-1.645 11.954-4.938 3.164-3.289 4.75-7.695 4.75-13.219 0-5.531-1.586-9.941-4.75-13.234-3.168-3.29-7.153-4.938-11.953-4.938-4.875 0-8.899 1.649-12.063 4.938-3.168 3.293-4.75 7.703-4.75 13.234 0 5.524 1.582 9.93 4.75 13.219 3.164 3.293 7.188 4.938 12.063 4.938ZM1061.905 418.496c0 .25-.125 1.96-.375 5.125h-49.61c.895 4.062 3.008 7.273 6.344 9.625 3.332 2.355 7.477 3.53 12.438 3.53 3.406 0 6.425-.503 9.062-1.515 2.645-1.02 5.11-2.625 7.39-4.812l10.11 10.969c-6.18 7.062-15.195 10.593-27.047 10.593-7.398 0-13.937-1.437-19.625-4.312-5.687-2.883-10.078-6.883-13.172-12-3.086-5.125-4.625-10.938-4.625-17.438 0-6.425 1.52-12.218 4.563-17.375 3.05-5.156 7.238-9.175 12.562-12.062 5.32-2.883 11.274-4.328 17.86-4.328 6.414 0 12.222 1.382 17.422 4.14 5.195 2.762 9.28 6.727 12.25 11.89 2.968 5.157 4.453 11.15 4.453 17.97Zm-34.016-19.625c-4.305 0-7.918 1.218-10.844 3.656-2.93 2.437-4.714 5.773-5.359 10h32.297c-.649-4.145-2.434-7.457-5.36-9.938-2.93-2.476-6.507-3.718-10.734-3.718Zm0 0"
      fill="#100f0d"
    />
  </svg>
)

export default SvgComponent
